import { Component } from '@angular/core';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faUserHeadset } from '@fortawesome/pro-regular-svg-icons';

@Component({
	selector: 'app-coach-icon',
	template: '<fa-icon [icon]="icon" />',
	standalone: true,
	imports: [FontAwesomeModule]
})
export class CoachIconComponent {
	icon = faUserHeadset;
}
